<div class="share-link">
  <button class="share-button" (click)="onButtonClick()">
    <span class="share-button__title" i18n>Get a link to the record</span>
    <span class="share-button__badge" *ngIf="processing === false">WWW</span>
    <span class="share-button__badge" *ngIf="processing" i18n>Getting URL</span>
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share-link/share-link.component.html